import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import DashSidebar from './DashSidebar';
import AddOrder from './AddOrder';
import UpdateOrder from './UpdateOrder';

const DashOrder = () => {
    const location = useLocation();
    // Determine the active class based on the current route
    const getActiveClass = (route) => {
        return location.pathname === route ? "active" : "";
    };
    return (
        <>
            <section className="mt-3">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-2">
                            <DashSidebar activeClass={getActiveClass("/dashboard")} />
                        </div>
                        <div className="col-sm-10 light-border p-4">
                            <div className="control-btn-nav pb-3 row">
                                <div className="col-sm-9">
                                    <h3><b>Order List </b></h3>
                                </div>
                                <div className="col-sm-3 d-flex align-items-center justify-content-end">
                                    {/* <Link className="ms-4 text-dark" data-bs-toggle="modal" data-bs-target="#exportModal">
                                        Export
                                    </Link> */}
                                    {/* <ExportJewelry /> */}

                                    {/* <Link className="ms-4 text-dark" data-bs-toggle="modal" data-bs-target="#importModal">
                                        Import
                                    </Link> */}
                                    {/* <UploadProduct /> */}

                                    <Link className="ms-4 btn btn__primary" data-bs-toggle="modal" data-bs-target="#addproductModal">
                                        New Order
                                    </Link>
                                    <AddOrder /> 
                                </div>
                            </div>


                            <div className="content">
                                <UpdateOrder />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default DashOrder